export const configPaginate = {
  page_size: 5,
  page_sizes: [5, 10, 15, 20],
  page_sizes_mobile: [4, 5, 10, 15, 20],
};
